// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hs","advertCardNum":"c-a_ht"};